<template>
    <v-layout row wrap>
        <loading-component :value="loading"/>
        <v-dialog :value="!!active_ticket_dialog" @input="active_ticket_dialog = null">
            <v-card>
                <v-card-title primary-title class="title">
                    Choose user to assign the ticket to
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <choose-user-mutli
                            v-model="user"
                            :multi="false"
                            return-object
                            label="User"
                    />
                    <v-btn color="primary" @click="assign">
                        Assign
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-flex xs12>
            <v-label>
                Reject Reasons
            </v-label>
            <v-chip v-for="value in [...$store.state.user.settings.REJECT_AGAINST_AI_OPTIONS,'null']"
                    :color="reject_reasons.indexOf(value) !== -1 ? 'primary' : 'grey'"
                    text-color="white"
                    @click="selectReason('reject',value)">
                {{value === 'null' ? 'Other' : value}}
            </v-chip>
        </v-flex>
        <v-flex xs12>
            <v-label>
                Cancel Reasons
            </v-label>
            <v-chip v-for="value in [...$store.state.user.settings.CANCEL_BEFORE_LIMIT_OPTIONS,'null']"
                    :color="cancel_reasons.indexOf(value) !== -1 ? 'primary' : 'grey'"
                    @click="selectReason('cancel',value)"
                    text-color="white">
                {{value === 'null' ? 'Other' : value}}
            </v-chip>
        </v-flex>
        <v-layout justify-end class="pa-2">
            <v-btn color="primary" @click="only_unassigned = !only_unassigned">
                Show {{only_unassigned ? "All" : "Only Not Assigned"}}
            </v-btn>
        </v-layout>
        <v-flex xs12>

            <DataTable
                    ref="datatable"
                    :url="api.ACTIONS.CANCELLATION_TICKETS"
                    :initial-url-search-params="params"
                    :fields-hidden-main="fieldsHiddenMain"
                    :fields-extra-main="fieldsExtraMain"
                    :enable-add="false"
                    :enable-edit="false"
                    :enable-delete="false"
                    :actions-extra-main="actionsExtraMain"
                    :conditional-action="conditionalAction"
                    disable-search
                    :formatter="formatter"
                    :titles="titles"
                    title="Cancellation Table"
            />
        </v-flex>

    </v-layout>

</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import ChooseUserMutli from "@/components/wasilni/input/ChooseUserMutli";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        components: {LoadingComponent, DataTable, ChooseUserMutli},
        title: "Cancellation Table",
        name: "CancellationTable",
        data() {
            return {
                active_ticket_dialog: null,
                user: null,
                loading: false,
                reject_reasons: [...this.$store.state.user.settings.REJECT_AGAINST_AI_OPTIONS, 'null'],
                cancel_reasons: [...this.$store.state.user.settings.CANCEL_BEFORE_LIMIT_OPTIONS, 'null'],
                only_unassigned: false
            }
        },
        methods: {
            selectReason(type, val) {
                const typeName = type + '_reasons';

                if (this[typeName].indexOf(val) === -1)
                    this[typeName] = [...this[typeName], val];
                else
                    this[typeName] = this[typeName].filter(i => i !== val);
            },
            async assign() {
                if (!this.user) {
                    alert("Choose User");
                    return;
                }
                this.loading = true;

                await this.axios.put(
                    'ticket/' + this.active_ticket_dialog + '/action',
                    {
                        action_id: 2,
                        data: {
                            user_id: this.user.id
                        }
                    }
                );

                this.$refs.datatable.editItemInTable(
                    (item) => item.id === this.active_ticket_dialog, {user: this.user, user_id: this.user.id}
                );

                this.active_ticket_dialog = null;
                window.getApp.$emit("SHOW_TOAST", "Assigned", "green");

                this.loading = false;
            }
        },
        computed: {
            params() {
                const params = new URLSearchParams();
                for (let reason of this.reject_reasons)
                    params.append("reject_reasons[]", reason);
                for (let reason of this.cancel_reasons)
                    params.append("cancel_reasons[]", reason);
                if (this.only_unassigned)
                    params.append("only_unassigned", "");
                return params;
            },
            fieldsExtraMain() {
                return {
                    passenger_name(val) {
                        return val.author.passenger.first_name + " " + val.author.passenger.last_name + "#" + val.author.passenger_id;
                    },
                    captain_name(val) {
                        if (!val.author.ride_id && !val.author.ai_booking)
                            return "N\\A";

                        if (!!val.author.ride_id)
                            return val.author.ride.captain.first_name + " " + val.author.ride.captain.last_name + "#" + val.author.ride.captain_id;
                        else
                            return val.author.ai_booking.captain.first_name + " " + val.author.ai_booking.captain.last_name + "#" + val.author.ai_booking.captain_id;
                    },
                    ticket_agent(val) {
                        if (!val.user_id)
                            return "N\\A";

                        return val.user.first_name + " " + val.user.last_name + "#" + val.user_id;
                    }
                }
            },
            fieldsHiddenMain() {
                return [
                    "author_type",
                    "author_id",
                    "subject_type",
                    "subject_id",
                    "type_id",
                    "status",
                    "deleted_at",
                    "updated_at",
                    "user_id",
                    'author',
                    "user"
                ]
            },
            titles() {
                return {
                    "id": "#",
                    "data": "Reason",
                    "subject": "User",
                    "created_at": "Action Date",
                    "type": "Type",
                    "passenger_name": "Passenger Name",
                    "captain_name": "Captain Name",
                    "ticket_agent": "Ticket Agent"
                }
            },
            formatter() {
                return {
                    data(val) {
                        const answers = val.answers;
                        const optionKey = Object.keys(answers)[0];
                        const otherKey = Object.keys(answers)[1];

                        return answers[optionKey] ? answers[optionKey] : answers[otherKey] + '(other)';
                    },
                    subject(val) {
                        return val.first_name + " " + val.last_name + "#" + val.id;
                    }
                };
            },
            conditionalAction() {
                return {
                    resolveTicket(item) {
                        return item.status !== "SOLVED";
                    }
                }
            },
            actionsExtraMain() {
                return {
                    resolveTicket: {
                        title: "Resolve",
                        color: "primary",
                        action: async (item) => {
                            await this.axios.put(
                                'ticket/' + item.id + '/action',
                                {
                                    action_id: 1,
                                    data: {}
                                }
                            );

                            this.$refs.datatable.removeItemFromTable(item);

                            window.getApp.$emit("SHOW_TOAST", "Resolved", "green");
                        }
                    },
                    assignTicket: {
                        title: "Assign",
                        color: "secondary",
                        action: (item) => this.active_ticket_dialog = item.id
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>